import { render, staticRenderFns } from "./PurposeAction.vue?vue&type=template&id=4485dd38&"
import script from "./PurposeAction.vue?vue&type=script&lang=js&"
export * from "./PurposeAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports